<app-boilerplate>
    <h1>Your Events Coming Soon</h1>
    @if (upcomingEventBookings$ | async; as eventBookings){
        <div class="flex flex-wrap gap-4">
        @for (booking of eventBookings; track booking.bookingID){
            <app-event-booking-tile [booking]="booking"/>
        }
        </div>
    }
    <h1 class="mt-4">Your Past Events</h1>
    @if (pastEventBookings$ | async; as eventBookings){
        <div class="flex flex-wrap gap-4">
        @for (booking of eventBookings; track booking.bookingID){
            <app-event-booking-tile [booking]="booking"/>
        }
        </div>
        
    }
</app-boilerplate>
